import React from "react"
import { colors } from "../../data/Color"
import search from "../../utils/search"
import SearchBar from "./SearchBar"
import ColorGrid from "./ColorGrid"
import NoResults from "../NoResults"
import Container from "../Container"

class ColorFinder extends React.Component {
  state = {
    inputValue: "",
  }

  handleInputChange = event => this.setState({ inputValue: event.target.value })

  render() {
    const results = getResults(this.state.inputValue)
    return (
      <div>
        <SearchBar
          placeholder={`Search color by name or hex color code…`}
          label="Search"
          value={this.state.inputValue}
          onChange={this.handleInputChange}
        />
        <Container>
          {results.length !== 0 ? (
            <ColorGrid colors={results} />
          ) : (
            <NoResults value={this.state.inputValue} />
          )}
        </Container>
      </div>
    )
  }
}

function getResults(value) {
  return search(Object.values(colors), value, { keys: ["name", "prop.hex"] })
}

export default ColorFinder



// WEBPACK FOOTER //
// ./src/components/colorfinder/ColorFinder.js